<template>
  <div>
    <CottiService v-if="brand === 'COTTI'"/>
    <TeacatService v-else/>
  </div>
</template>

<script>
import CottiService from './components/cotti-service'
import TeacatService from './components/teacat-service'

export default {
  name: 'Service',
  components: {
    CottiService,
    TeacatService
  },
  data() {
    return {
      brand: ''
    }
  },
  mounted () {
    this.brand = this.$config.env.VUE_APP_BRAND
  }
  
}
</script>

<style scoped lang="scss">
</style>
